import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import App from './App.vue'
import './quasar'
import Routes from './router/routes'

//Packages
Vue.use(VueRouter);

Vue.prototype.$http = axios;

const router = new VueRouter({
  routes: Routes
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router: router,
}).$mount('#app');
